import { render, staticRenderFns } from "./AuthPage.vue?vue&type=template&id=61ce6a0a&"
import script from "./AuthPage.vue?vue&type=script&lang=ts&"
export * from "./AuthPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61ce6a0a')) {
      api.createRecord('61ce6a0a', component.options)
    } else {
      api.reload('61ce6a0a', component.options)
    }
    module.hot.accept("./AuthPage.vue?vue&type=template&id=61ce6a0a&", function () {
      api.rerender('61ce6a0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Auth/AuthPage.vue"
export default component.exports